import React, { useState, useEffect } from "react";
import Button from "../Button";
import useInView from "../../hooks/useInView";
import useHomepageCTA from "../../hooks/useHomepageCTA";

export default function CTASection() {
  const [ref, isInView] = useInView();
  const { headline, loading } = useHomepageCTA();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <section
      id="cta"
      ref={ref}
      className="bg-zinc-950"
      style={{ padding: isMobile ? "64px 0" : "128px 48px" }}
    >
      <div
        style={{
          maxWidth: "1024px",
          margin: isMobile ? "10px" : "0 auto",
          textAlign: "center",
          padding: isMobile ? "0 15px" : "0",
        }}
      >
        <h2
          style={{
            fontFamily: "Archivo, sans-serif",
            fontWeight: "900",
            letterSpacing: "-0.02em",
            fontVariationSettings: '"wght" 650, "wdth" 75',
            fontSize: "clamp(40px, 6vw + 16px, 90px)",
            lineHeight: "0.95",
            marginBottom: "24px",
            textTransform: "uppercase",
            minHeight: "180px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {!loading && (
            <span
              style={{
                display: "block",
                opacity: isInView ? 1 : 0,
                filter: `blur(${isInView ? 0 : 10}px)`,
                transform: `translateY(${isInView ? 0 : -20}px)`,
                transition: "opacity 0.8s ease-out 0.5s",
                whiteSpace: "pre-line",
              }}
            >
              {headline}
            </span>
          )}
        </h2>
        <p
          style={{
            fontSize: "20px",
            color: "#a1a1aa",
            marginBottom: "56px",
            maxWidth: "800px",
            margin: "0 auto 56px",
            lineHeight: "1.6",
          }}
        >
          Messy brief? Deadline yesterday? Let’s talk. – I work
          fast.
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "center",
          }}
        >
          <Button href="mailto:mail@rene-gebhardt.com">E-Mail me</Button>
          <Button href="https://wa.me/4917620191826" external>
            WhatsApp me
          </Button>
        </div>
      </div>
    </section>
  );
}